exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1GktsU7A0n9s-E9O5QB2TC .od-ShareHeader-linkSettings{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center}html[dir] ._1GktsU7A0n9s-E9O5QB2TC .od-ShareHeader-linkSettings{margin:0;padding:12px}html[dir] ._1GktsU7A0n9s-E9O5QB2TC .od-ModifyPermissions-section{padding:0}", ""]);

// exports
exports.locals = {
	"sharingDialog": "_1GktsU7A0n9s-E9O5QB2TC"
};